import { connect, } from 'react-redux';

import Footer from '../components/Footer';
import { onFooterReadMoreClick, onFooterPrivacyLinkClick, } from '../../sew-core/actions';

const mapStateToProps = (): object => ({});

const mapDispatchToProps = (dispatch,) => ({
  onFooterReadMoreClick: (): void => dispatch(onFooterReadMoreClick(),),
  onFooterPrivacyLinkClick: (): void => dispatch(onFooterPrivacyLinkClick(),),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Footer,);
